import React from 'react';
import Spinner from 'react-spinner-material';
import { HorizontalBar } from 'react-chartjs-2';

const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    layout: {
        padding: {
            left: 10,
            right: 20,
            top: 10,
            bottom: 10
        }
    },
    scales: {
        xAxes: [{
            gridLines: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
                drawBorder: false
            },
            ticks: {
                beginAtZero: true,
                fontColor: '#6B7280',
                fontSize: 11
            }
        }],
        yAxes: [{
            gridLines: {
                display: false
            },
            ticks: {
                fontColor: '#374151',
                fontSize: 12,
                padding: 10
            },
            barPercentage: 0.7,
            categoryPercentage: 0.8
        }]
    },
    tooltips: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)',
        titleFontSize: 13,
        bodyFontSize: 12,
        xPadding: 12,
        yPadding: 10,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
            title: function (tooltipItems, data) {
                const index = tooltipItems[0].index;
                return data.fullLabels ? data.fullLabels[index] : data.labels[index];
            }
        }
    }
};

// Gradient colors for top products
const colors = [
    '#3B82F6', // 1st - Blue
    '#6366F1', // 2nd - Indigo
    '#8B5CF6', // 3rd - Purple
    '#A855F7', // 4th - Violet
    '#C084FC', // 5th - Light Purple
];

const hoverColors = [
    '#2563EB',
    '#4F46E5',
    '#7C3AED',
    '#9333EA',
    '#A855F7',
];

export class TopProductsChart extends React.Component {
    render() {
        const { data, language } = this.props;

        if (!data) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <Spinner size={50} spinnerColor="#2CA8FF" spinnerWidth={2} visible={true} />
                </div>
            );
        }

        if (data.length === 0) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    color: '#9CA3AF',
                    fontSize: '14px'
                }}>
                    Sem dados
                </div>
            );
        }

        // Take top 5 products
        const topProducts = data.slice(0, 5);

        // Store full labels for tooltips
        const fullLabels = topProducts.map(d => d.name || d.label || 'Desconhecido');

        // Truncate labels for display
        const truncatedLabels = fullLabels.map(label =>
            label.length > 25 ? label.substring(0, 25) + '...' : label
        );

        const dataChart = {
            labels: truncatedLabels,
            fullLabels: fullLabels,
            datasets: [{
                label: language?.inspections || 'Inspeções',
                data: topProducts.map(d => d.total || d.qtt || 0),
                backgroundColor: colors,
                hoverBackgroundColor: hoverColors,
                borderWidth: 0,
                borderRadius: 4,
                barThickness: 'flex',
                maxBarThickness: 32
            }]
        };

        return (
            <HorizontalBar data={dataChart} options={options} />
        );
    }
}
